<template>
  <div class="icon-switch" @click="clickIcon" @mouseover="mouseoverIcon" @mouseleave="mouseleaveIcon">
    <img :src="src">
  </div>
</template>

<script>
  import qrcodeImg from '../../assets/images/new-login-2018/qrcode.png'
  import qrcodeHoverImg from '../../assets/images/new-login-2018/qrcode_hover.png'
  import passwordImg from '../../assets/images/new-login-2018/password.png'
  import passwordHoverImg from '../../assets/images/new-login-2018/password_hover.png'
  import uploadWebEvent from '../common/UploadWebEvent.js'
  import AppInfo from '../../appInfo/index'
  export default {
    data () {
      return {
        src: '',
        params: {
          // 跳转扫码登录页面
          qrcode: {
            router: '/login/scan'
          },
          // 跳转账号登录页面
          account: {
            router: '/login/signin'
          }
        },
        isGenericVersion: AppInfo.isGenericVersion()
      }
    },
    props: ['type'],
    mounted () {
      this.mouseleaveIcon()
    },
    methods: {
      clickIcon () {
        if (this.$route.path === '/login/scan') {
          if (!this.isGenericVersion) {
            uploadWebEvent('SCAN_TO_SIGNIN') // 埋点统计：扫码界面切换回登录界面
          }

          if (Object.keys(this.$route.query).length === 0) {
            history.back()
          } else {
            this.$router.push({path: '/login/signin'})
          }
        } else {
          if (!this.isGenericVersion) {
            uploadWebEvent('SIGNIN_TO_SCAN') // 埋点统计：登录页面切换到扫码页面
          }
          this.$router.push({path: '/login/scan'})
        }
      },
      mouseoverIcon () {
        if (this.type === 'qrcode') {
          this.src = qrcodeHoverImg
        } else {
          this.src = passwordHoverImg
        }
      },
      mouseleaveIcon () {
        if (this.type === 'qrcode') {
          this.src = qrcodeImg
        } else {
          this.src = passwordImg
        }
      }
    }
  }
</script>

<style lang="less" scoped>
	.icon-switch {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 20px;
    margin-left: 395px;
    cursor: pointer;
    img {
      display: block;
      margin: 0 auto;
      // width: 24px;
      // height: 24px;
    }
  }
</style>



// WEBPACK FOOTER //
// Iconswitch.vue?2390d6bf